<template>
  <div class="device-detail-event-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent label-position="left">
        <el-form-item>
          <el-radio-group v-model="formSearch.eventType" @change="onPageChange({ page: 1 })">
            <el-radio-button label="">{{ $t('Common.com_all') }}</el-radio-button>
            <el-radio-button label="23">{{ eventTypeDic['23'] }}</el-radio-button>
            <el-radio-button label="22">{{ eventTypeDic['22'] }}</el-radio-button>
            <el-radio-button label="21">{{ eventTypeDic['21'] }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right">
          <el-button class="table-set" style="vertical-align: top" @click="dialogVisible = true">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 日期过滤 -->
        <el-form-item style="float: right">
          <!-- 部件编码  -->
          <search-input v-model="formSearch.eventCode" :placeholder="$t('dms_device_detail_event.sjdmV3dmV4dm')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            v-model="formSearch.eventQueryType"
            code="event_query_type"
            :placeholder="$t('Common.com_please_select')"
            width="100px"
            :clearable="false"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-radio-group v-model="eventType" @change="onPageChange({ page: 1 })">
            <el-radio-button :label="item.value" v-for="(item, index) in eventTypeData" :key="index">{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_device_detail_event.bu_jian_bian_ma')" style="width: 30% !important">
          <el-input v-model="formSearch.componentCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_device_detail_event.shi_jian_shi_jian')" style="width: 35% !important">
          <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="eventIntervalDays" :clearable="false"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table :data="tableList" :column="tableColumn" ref="tb1" @filter="filterChange" @sort="sortChange" max-height="600"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <device-date-event-datePicker v-if="dialogVisible" @close="dialogVisible = false" @success="exportTable" v-model="exportTimer"></device-date-event-datePicker>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import deviceDateEventDatePicker from '@/components/device_detail_date_datePicker.vue';

export default {
  mixins: [resetFormSearchMixins],
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },

    isModem: { type: Boolean, default: false },
  },
  computed: {
    eventTypeData() {
      return [
        {
          label: this.$t('dms_device_detail_event.zai_li_xian_shi_jian'),
          value: 0,
        },
        {
          label: this.$t('dms_device_detail_event.ji_qi_shi_jian'),
          value: 1,
        },
      ];
    },
  },
  components: {
    deviceDateEventDatePicker,
  },
  data() {

    return {
      tableCode: 'device_detail_event',
      provide: true,
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        bodyNum: '',
        startDate: '',
        endDate: '',
        timer: [this.$momentWorld(moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment().format('YYYY-MM-DD 23:59:59'))],
        uploadStartDate: '',
        uploadEndDate: '',
        eventType: '',
        uploadTimer: '',
        // startDate: '',
        componentCode: '',
        eventCode: '',
        modemSn: '',
        eventQueryType: '0',
      },
      eventTypeDic: {},
      exportTimer: '',
      tableList: [],
      totalRows: 0,
      eventType: 1,
      timeSection: '',
      dialogVisible: false,


    };
  },
  mounted: function () {
    this.formSearch.bodyNum = this.deviceInfo.bodyNum;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getTableList();
    this.getDictionary('ice_open_event_type', (data) => {
      this.eventTypeDic = this.$listTransObject(data.ice_open_event_type);
    });
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      // this.formSearch.endDate = moment(this.formSearch.startDate).format('YYYY-MM-DD 23:59:59');
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      this.formSearch.startDate = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : undefined;
      this.formSearch.endDate = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : undefined;
      this.formSearch.uploadStartDate = this.formSearch.uploadTimer && this.formSearch.uploadTimer[0] ? this.formSearch.uploadTimer[0] : undefined;
      this.formSearch.uploadEndDate = this.formSearch.uploadTimer && this.formSearch.uploadTimer[1] ? this.formSearch.uploadTimer[1] : undefined;

      if (this.isModem) {
        this.formSearch.modemSn = this.deviceInfo.modemSn;
        //  '在/离线事件',
        if (this.eventType === 0) {
          this.$getJSON(apis.modemBatteryComponentOnlineEventPage, {
            ...this.formSearch,
          }).then((res) => {
            this.tableList = res.data.list;
            this.totalRows = res.data.total;
          });
        } else {
          this.$getJSON(apis.modemBatteryComponentEventPage, {
            ...this.formSearch,
          }).then((res) => {
            this.tableList = res.data.list;
            this.totalRows = res.data.total;
          });
        }
      } else {
        //  '在/离线事件',
        if (this.eventType === 0) {
          this.$getJSON(apis.DeviceResumeComponentOnlinePage, {
            ...this.formSearch,
          }).then((res) => {
            this.tableList = res.data.list;
            this.totalRows = res.data.total;
          });
        } else {
          //  '机器事件',
          this.$getJSON(apis.DeviceResumeComponentEventPage, {
            ...this.formSearch,
          }).then((res) => {
            this.tableList = res.data.list;
            this.totalRows = res.data.total;
          });
        }
      }
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
      this.$nextTick(() => {
        this.$refs.tb1.$refs.tb1.bodyWrapper.scrollTop = 0;
      });
    },
    // 数据导出
    exportTable: function () {
      const startDate = this.exportTimer && this.exportTimer[0] ? this.exportTimer[0] : undefined;
      const endDate = this.exportTimer && this.exportTimer[1] ? this.exportTimer[1] : undefined;
      if (this.isModem) {
        this.$exportFlie(this.eventType === 0 ? apis.modemBatteryComponentOnlineEventExport : apis.modemBatteryComponentEventExport, {
          modemSn: this.deviceInfo.modemSn,
          pageSize: 50,
          pageNum: 1,
          startDate,
          endDate,
        }).then(() => {});
      } else {
        this.$exportFlie(this.eventType === 0 ? apis.DeviceResumeComponentOnlineEventExport : apis.DeviceResumeComponentEventExport, {
          bodyNum: this.deviceInfo.bodyNum,
          pageSize: 50,
          pageNum: 1,
          startDate,
          endDate,
        }).then(() => {});
      }
    },
    onRangeChange() {
      // this.anchorDate = null;
    },
  },
};
</script>

<style lang="scss">
.device-detail-event-bd {
  padding: 8px 24px 44px 24px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
</style>
